/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const GetApiV3DailyStatsMaxQueryTransactionsPerSecTillDateFormat = {
  Json: "json",
  Csv: "csv",
} as const;
export type GetApiV3DailyStatsMaxQueryTransactionsPerSecTillDateFormat =
  ClosedEnum<typeof GetApiV3DailyStatsMaxQueryTransactionsPerSecTillDateFormat>;

export type GetApiV3DailyStatsMaxQueryTransactionsPerSecTillDateRequest = {
  /**
   * End Timestamp
   */
  end?: number | null | undefined;
  format?:
    | GetApiV3DailyStatsMaxQueryTransactionsPerSecTillDateFormat
    | undefined;
  /**
   * Start Timestamp
   */
  start?: number | null | undefined;
};

/** @internal */
export const GetApiV3DailyStatsMaxQueryTransactionsPerSecTillDateFormat$inboundSchema:
  z.ZodNativeEnum<
    typeof GetApiV3DailyStatsMaxQueryTransactionsPerSecTillDateFormat
  > = z.nativeEnum(GetApiV3DailyStatsMaxQueryTransactionsPerSecTillDateFormat);

/** @internal */
export const GetApiV3DailyStatsMaxQueryTransactionsPerSecTillDateFormat$outboundSchema:
  z.ZodNativeEnum<
    typeof GetApiV3DailyStatsMaxQueryTransactionsPerSecTillDateFormat
  > = GetApiV3DailyStatsMaxQueryTransactionsPerSecTillDateFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3DailyStatsMaxQueryTransactionsPerSecTillDateFormat$ {
  /** @deprecated use `GetApiV3DailyStatsMaxQueryTransactionsPerSecTillDateFormat$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3DailyStatsMaxQueryTransactionsPerSecTillDateFormat$inboundSchema;
  /** @deprecated use `GetApiV3DailyStatsMaxQueryTransactionsPerSecTillDateFormat$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3DailyStatsMaxQueryTransactionsPerSecTillDateFormat$outboundSchema;
}

/** @internal */
export const GetApiV3DailyStatsMaxQueryTransactionsPerSecTillDateRequest$inboundSchema:
  z.ZodType<
    GetApiV3DailyStatsMaxQueryTransactionsPerSecTillDateRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    end: z.nullable(z.number().int()).default(null),
    format:
      GetApiV3DailyStatsMaxQueryTransactionsPerSecTillDateFormat$inboundSchema
        .default("json"),
    start: z.nullable(z.number().int()).default(null),
  });

/** @internal */
export type GetApiV3DailyStatsMaxQueryTransactionsPerSecTillDateRequest$Outbound =
  {
    end: number | null;
    format: string;
    start: number | null;
  };

/** @internal */
export const GetApiV3DailyStatsMaxQueryTransactionsPerSecTillDateRequest$outboundSchema:
  z.ZodType<
    GetApiV3DailyStatsMaxQueryTransactionsPerSecTillDateRequest$Outbound,
    z.ZodTypeDef,
    GetApiV3DailyStatsMaxQueryTransactionsPerSecTillDateRequest
  > = z.object({
    end: z.nullable(z.number().int()).default(null),
    format:
      GetApiV3DailyStatsMaxQueryTransactionsPerSecTillDateFormat$outboundSchema
        .default("json"),
    start: z.nullable(z.number().int()).default(null),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3DailyStatsMaxQueryTransactionsPerSecTillDateRequest$ {
  /** @deprecated use `GetApiV3DailyStatsMaxQueryTransactionsPerSecTillDateRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3DailyStatsMaxQueryTransactionsPerSecTillDateRequest$inboundSchema;
  /** @deprecated use `GetApiV3DailyStatsMaxQueryTransactionsPerSecTillDateRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3DailyStatsMaxQueryTransactionsPerSecTillDateRequest$outboundSchema;
  /** @deprecated use `GetApiV3DailyStatsMaxQueryTransactionsPerSecTillDateRequest$Outbound` instead. */
  export type Outbound =
    GetApiV3DailyStatsMaxQueryTransactionsPerSecTillDateRequest$Outbound;
}

export function getApiV3DailyStatsMaxQueryTransactionsPerSecTillDateRequestToJSON(
  getApiV3DailyStatsMaxQueryTransactionsPerSecTillDateRequest:
    GetApiV3DailyStatsMaxQueryTransactionsPerSecTillDateRequest,
): string {
  return JSON.stringify(
    GetApiV3DailyStatsMaxQueryTransactionsPerSecTillDateRequest$outboundSchema
      .parse(getApiV3DailyStatsMaxQueryTransactionsPerSecTillDateRequest),
  );
}

export function getApiV3DailyStatsMaxQueryTransactionsPerSecTillDateRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiV3DailyStatsMaxQueryTransactionsPerSecTillDateRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3DailyStatsMaxQueryTransactionsPerSecTillDateRequest$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetApiV3DailyStatsMaxQueryTransactionsPerSecTillDateRequest' from JSON`,
  );
}
